module.exports = __webpack_public_path__ + "media/images/posts/master_Class-42ca03f628322d94cd32d95abb226037.jpg";